import { render } from "./MWUpdateHome.vue?vue&type=template&id=7adef990"
import script from "./MWUpdateHome.vue?vue&type=script&lang=js"
export * from "./MWUpdateHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__